import { Typography } from '@snack-uikit/typography';
import { useSearchParams } from 'next/navigation';

import { SOURCE_PLATFORM_QUERY_PARAM_NAME, STATIC_PAGES_PATH_NAMES } from '@/constant/routes';
import { SERP_QUERY_PARAMS_NAMES } from '@/constant/serp';
import { useSERPFeedback } from '@/hooks/serp';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { isEmpty } from '@/utils/common';
import { addQueryParamToString } from '@/utils/navigation';

import { Feedback } from '../Feedback';
import { LinkWrapper } from '../LinkWrapper';
import s from './styles.module.scss';

const addPlatformsToQuery = (query: string, platforms: string[]) => {
  const platformParams = platforms.map(platform => `${SERP_QUERY_PARAMS_NAMES.platforms}=${platform}`).join('&');
  if (isEmpty(query)) return platformParams;

  return `${query}&${platformParams}`;
};

export function SearchModalFooter({
  totalCount,
  searchKeyword,
  platforms,
  searchRequestID,
}: {
  totalCount: number;
  searchKeyword: string;
  platforms: string[];
  searchRequestID: string;
}) {
  const searchParams = useSearchParams();
  const {
    submitFeedbackFormHandler,
    isOpenFeedbackForm,
    isLoadingFeedback,
    chooseScoreFeedbackHandler,
    isOpenThanksBlock,
    setIsOpenThanksBlock,
    setIsOpenFeedbackForm,
  } = useSERPFeedback({ searchRequestID, shadowInput: searchParams.get(SERP_QUERY_PARAMS_NAMES.shadowInput) });

  const platform = useCurrentPlatform();
  const addSourcePlatformToQuery = (url: string) =>
    addQueryParamToString(url, SOURCE_PLATFORM_QUERY_PARAM_NAME, platform);
  const addPhraseToQuery = (url: string) => addQueryParamToString(url, SERP_QUERY_PARAMS_NAMES.phrase, searchKeyword);

  return (
    <div className={s.footer_wrapper}>
      <LinkWrapper
        textWrapper={Typography.SansLabelL}
        link={addPlatformsToQuery(addPhraseToQuery(addSourcePlatformToQuery(STATIC_PAGES_PATH_NAMES.serp)), platforms)}
      >
        ВСЕ РЕЗУЛЬТАТЫ ({totalCount}) &gt;
      </LinkWrapper>
      <Feedback
        isOpenFeedbackForm={isOpenFeedbackForm}
        setIsOpenFeedbackForm={setIsOpenFeedbackForm}
        isOpenThanksBlock={isOpenThanksBlock}
        setIsOpenThanksBlock={setIsOpenThanksBlock}
        onSubmitForm={submitFeedbackFormHandler}
        onChooseScore={chooseScoreFeedbackHandler}
        isLoadingSendFeedback={isLoadingFeedback}
      />
    </div>
  );
}
